import { createFileRoute } from '@tanstack/react-router';
import { TabelasPage, lerBuscaTabelas } from '@/components/tabelas-preco';

export const Route = createFileRoute('/_app/cadastros/tabelas')({
  validateSearch: (bruto: Record<string, unknown>) => lerBuscaTabelas(bruto),
  component: TabelasRota,
});

function TabelasRota() {
  return <TabelasPage busca={Route.useSearch()} />;
}
